var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"batteries"},[_c('div',{staticClass:"miles-estimated"},[_c('h2',[_vm._v(_vm._s(_vm.txt.range.batteries.title))]),_c('p',{staticClass:"speed"},[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.txt.common.unit))])])])}
var staticRenderFns = []

export { render, staticRenderFns }